<template>
  <div v-if="!qrcode" class="nearby_wrap">
    <div class="bg">
      <img @click="openLocation()" src="./images/nearby.png" alt="" />
    </div>
  </div>
  <div v-else-if="commonStore.isForPC" class="nearby_wrap nearby_qr nearby_qr_pc">
    <div class="bg">
      <img v-if="platform.includes('yjs')" src="./images/yjs_nearby_pc.png" alt="" />
      <img v-else src="./images/job_nearby_pc.png" alt="" />
      <div class="sub_btn" @click="refreshPage()">已填写，去刷新</div>
    </div>
  </div>
  <div v-else class="nearby_wrap nearby_qr">
    <div class="bg">
      <img v-if="platform.includes('yjs')" src="./images/yjs_nearby.png" alt="" />
      <img v-else src="./images/job_nearby.png" alt="" />
      <div class="sub_btn" @click="refreshPage()">已填写，去刷新</div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "JobNearby",
  props: {},
  computed: {
    ...mapState(["commonStore"]),
    isLogin() {
      return this.$store.getters.isLogin;
    },
    qrcode(){
      return !this.isApp&&!this.isMobile
      // return true
    },
    isApp() {
      return ["51jobApp", "yjsApp"].includes(this.platform)
    },
    isMobile() {
      return ["51jobM", "yjsM"].includes(this.platform)
    },
    platform() {
      return this.$store.getters.platform;
    },
  },
  methods: {
    refreshPage(){
      if(!this.isLogin){
        this.$base.toLogin();
      }else{
        location.reload()
      }
    },
    openLocation() {
      if(!this.isLogin){
        this.$base.toLogin();
        return
      }
      let yjs = this.platform.includes("yjs")
      let job51 = this.platform.includes("51job")
      console.log(this.commonStore,'intention');
      if(this.isApp){
        let url
        if (yjs) {
          this.$base.watchAppCover(this.refreshPage);
          const intentions = this.commonStore.intention;
          if (intentions) {
            url = `yingjiesheng://home/openUsualAddress?area=${intentions.expectArea}&areaString=${intentions.expectAreaString}`;
          } else {
            url = `yingjiesheng://home/openUsualAddress`;
          }
        } else if (job51) {
          this.$base.watchAppCover(this.refreshPage);
          url = "qiancheng://home/show_job_location_page";
        }
        window.location.href = url
      }else{
        if (yjs) {
          window.location.href = "https://q.yingjiesheng.com/download?deeplink=yingjiesheng%3A%2F%2Fhome%2FopenUsualAddress";
        } else if (job51) {
          window.location.href = "https://app.51job.com/?deeplink=qiancheng%3A%2F%2Fhome%2Fshow_job_location_page";
        }
      }
    },
  }
};
</script>
<style scoped lang="less">
.nearby_wrap {
  width: 100%;
  .bg {
    margin: 4px 8px 0;
    height: 235px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 273px;
      height: auto;
    }
  }
}
.nearby_qr{
  .bg {
    height: 269px;
    img{
      width: 311px;
      .adapt_pc_widescreen & {
        width: 460px;
      }
    }
    .sub_btn {
      width: 154px;
      height: 36px;
      line-height: 36px;
      margin: 6px auto 0;
      border-radius: 22px;
      opacity: 1;
      background: linear-gradient(180deg, #ffb240 2%, #ff6300 100%);
      box-sizing: border-box;
      border: 1px solid #ffe7ce;
      box-shadow: inset 0px 3px 9px 0px #ff6906;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      color: #ffffff;
    }
  }
}
.nearby_qr_pc{
  .bg {
    height: 351px;
    img{
      width: 460px;
    }
    .sub_btn {
      width: 232px;
      height: 48px;
      line-height: 48px;
      margin: 20px auto 0;
      border-radius: 32px;
      opacity: 1;
      box-sizing: border-box;
      border: 1px solid #ffe7ce;
      background: linear-gradient(180deg, #FFB240 2%, #FF6300 100%);
      box-shadow: inset 0px 4px 12px 0px #FF6906;
      font-size: 22px;
      font-weight: 600;
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
